import React from 'react';
import { ArrowRightIcon, CheckIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionBadge } from '../SectionBadge';
import { PremiumOfferCard } from '../PremiumOfferCard';
import { Reveal } from '../Reveal';
import { useLaunchCountdown } from '../../hooks/useLaunchCountdown';
import { PRICING, PRICING_OPTIONS } from '../../data/content';
const BENEFITS = ['6 tomos completos para planificar tus clases', '5 bonos exclusivos incluidos', 'Acceso digital de por vida', 'Actualizaciones gratuitas', 'Garantía de 7 días sin preguntas'];
export function Pricing() {
  const {
    isExpired
  } = useLaunchCountdown();
  const megapack = PRICING_OPTIONS[0];
  if (!megapack) return null;
  return <section className="w-full px-5 py-12 sm:py-16" aria-labelledby="pricing-title" data-id="element-187" data-mp="3bi0dx2gq4tn">
      <div className="mx-auto max-w-5xl" data-id="element-188" data-mp="2064fv86qk4rm">
        <Reveal className="mx-auto max-w-xl text-center" data-id="element-189" data-mp="253mmut1709wz">
          <SectionBadge tone="dark" data-id="element-190" data-mp="25465yd2kx4cl">
            {isExpired ? 'Acceso disponible' : 'Oferta de lanzamiento'}
          </SectionBadge>
          <h2 id="pricing-title" tabIndex={-1} className="mt-5 font-display text-2xl leading-tight text-snow outline-none sm:text-4xl" data-id="element-191" data-mp="16k08kg7o7ubv">
            Elegí tu <span className="u-lime" data-id="element-192" data-mp="11ikl6hi0tbqb">Megapack</span>
          </h2>
        </Reveal>

        <div className="mx-auto mt-8 grid max-w-xl gap-10" data-id="element-193" data-mp="xh8ue8neukgj">
        <Reveal delay={60} data-id="element-194" data-mp="1u8jguvqq073y">
          <article className="flex flex-col rounded-3xl border border-ink-line bg-ink-card p-6 shadow-[0_18px_40px_rgba(0,0,0,0.32)] sm:p-8" data-id="element-195" data-mp="1u8t96pz8mqct">
            <header className="text-center" data-id="element-196" data-mp="1l8o2ki1vbvzp">
              <h3 className="font-display text-xl text-snow sm:text-2xl" data-id="element-197" data-mp="1l7cwgbkyac5f">{megapack.name}</h3>
              <p className="mt-1.5 text-sm font-extrabold uppercase tracking-wide text-lime" data-id="element-198" data-mp="1g91o65ab09pb">
                {megapack.description}
              </p>

              {!isExpired && <p className="mt-5 text-sm font-semibold text-snow-muted line-through" data-id="element-199" data-mp="4tmqt0e6nfto">
                  {PRICING.totalValueOld} {PRICING.currency}
                </p>}
              <p className={`font-display text-5xl leading-none text-snow sm:text-6xl ${isExpired ? 'mt-5' : 'mt-1'}`} data-id="element-200" data-mp="bbg5fpg8f1i6">
                {megapack.price}{' '}
                <span className="font-sans text-base font-bold text-snow-muted" data-id="element-201" data-mp="3tim2w0utpiqh">{PRICING.currency}</span>
              </p>
              {!isExpired && <p className="mt-2 text-sm font-extrabold text-lime" data-id="element-202" data-mp="3jpos6gw2oy2f">Ahorrás {PRICING.savings} {PRICING.currency}</p>}
              <p className="mt-2 text-sm font-bold text-snow" data-id="element-203" data-mp="3oird60msaz70">
                {isExpired ? 'Precio actualizado · un solo pago' : 'Un solo pago, sin suscripciones'}
              </p>
            </header>

            <ul className="mt-6 space-y-3 border-t border-snow/25 pt-6" aria-label={`Incluye ${megapack.name}`} data-id="element-204" data-mp="3epk9qlbltt9k">
              {BENEFITS.map(benefit => <li key={benefit} className="flex items-start gap-3 text-sm font-medium leading-snug text-snow sm:text-base" data-id="element-205" data-mp="35px6rv388fee">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-206" data-mp="2m5ot0tca1pg2" />
                  {benefit}
                </li>)}
            </ul>

            <div className="mt-auto pt-7" data-id="element-207" data-mp="2v6mr6v01b2qq">
              <CtaButton variant="outline" className="w-full" href={megapack.checkoutUrl} data-id="element-208" data-mp="2v3ih5gzw1cs5">
                Quiero mi Megapack ahora <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-209" data-mp="353rh95x03ict" />
              </CtaButton>
            </div>
          </article>
        </Reveal>

        <Reveal delay={60} data-id="element-210" data-mp="304erodeqvx6j">
          <PremiumOfferCard data-id="element-211" data-mp="3033niche0new" />
        </Reveal>
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-xs font-semibold text-snow-muted" data-id="element-212" data-mp="3etayy88z9663">
          <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-213" data-mp="39v9djgo2wurg" />
          Pago seguro · Acceso inmediato por email
        </p>
      </div>
    </section>;
}